/* eslint-disable */
import React from 'react';
import {toast} from 'react-toastify';
import {actions} from 'react-redux-form';
import store, {history} from '../store';
import irelandApi from '../irelandApi';
import setAuthorizationToken from '../utils/tokenUtils';
import {getMyProfile} from './user';
import ToastMessage from '../components/common/toast-message';
import {getMarketingConsent} from "./marketing_consent";

export const getYou = () => (dispatch) => {
  dispatch({type: 'GET_YOU_PENDING', payload: []});
  return irelandApi.get('/api/my_staff_members')
    .then((response) => {
      dispatch({type: 'GET_YOU_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_YOU_REJECTED', payLoad: error.data});
    });
};

export const getQuestions = () => (dispatch) => {
  dispatch({type: 'SECURITY_QUESTIONS_PENDING', payload: []});

  return irelandApi.get('/api/security_questions')
    .then((response) => {
      dispatch({type: 'SECURITY_QUESTIONS_FULFILLED', payLoad: response.data.data});
    })
    .catch((error) => {
      dispatch({type: 'SECURITY_QUESTIONS_REJECTED', payLoad: error});
    });
};

export const getInvitationInfo = token => (dispatch) => {
  dispatch({type: 'INVITATION_TOKEN_PENDING', payload: []});

  return irelandApi.get('/api/users/invitation/accept', {params: {invitation_token: token}})
    .then((response) => {
      const user = {
        ...response.data.user
      };
      if (user.email) {
        user.comms_email = 'true';
      } else if (user.mobile) {
        user.comms_mobile = 'true';
      }
      dispatch(actions.merge('deep.about_you.user', user));
      dispatch({type: 'INVITATION_TOKEN_FULFILLED', payLoad: response.data});
      let params= {};
      if (user.champion) {
        params = {params: {champion: true}};
      } else {
        params = {params: {customer_unique_number: response.data.outlet.customer_number}};
      }
      dispatch(getMarketingConsent(params));
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="warning" message="The given invitation token is invalid, please check the invitation email"/>);
      history.push('/');
      dispatch({type: 'INVITATION_TOKEN_REJECTED', payLoad: error});
    });
};


export const saveAboutYouStaff = (payload, registration, invitationToken) => {
  const data = {
    user: {...payload},
  };
  delete data.user.outlet;

  data.user.invitation_token = invitationToken;

  return irelandApi.patch('/api/users/invitation', data)
    .then((response) => {
      if (response.data && response.data.champion){
        toast.success('Please login via the new Champion app');
      } else {
        const token = response.headers.authorization.split(' ')[1];
        setAuthorizationToken(token);
        store.dispatch(getMyProfile('CURRENT_USER_PROFILE'));
        store.dispatch({type: 'FINISH_REGISTRATION'});
        if (registration.pending && registration.internal) {
          history.push('/your-store');
        } else {
          history.push('/about-ignite');
        }
      }
    })
    .catch((error) => {
      store.dispatch(actions.resetValidity('deep.about_you.user'));
      const errorData = {
        ...error.response.data.errors
      };
      return Promise.reject(errorData);
    });
};

export const saveAboutYouOwner = (payload, registration) => {
  const data = {
    user: {...payload},
    registration_token: registration.registration_token
  };
  delete data.user.outlet;

  return irelandApi.post('/api/users/about_you', data)
    .then((response) => {
      store.dispatch({
        type: 'SET_REGISTRATION_TOKEN',
        payLoad: {registration_token: response.data.registration_token}
      });
      if (registration.pending && registration.internal) {
        history.push('/your-store');
      } else {
        store.dispatch({type: 'UPDATE_YOU_FULFILLED', payLoad: response.data});
        history.push('/registration/your-store');
      }
    })
    .catch((error) => {
      store.dispatch(actions.resetValidity('deep.about_you.user'));
      store.dispatch({
        type: 'SET_REGISTRATION_TOKEN',
        payLoad: {registration_token: error.response.data.registration_token}
      });
      const data = {
        ...error.response.data.errors.user[0]
      };
      return Promise.reject(data);
    });
};



// WEBPACK FOOTER //
// ./src/actions/about-you.js